// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as EditBDefault } from '../../../assets/icons/default/general/edit-b.svg?react';
import { ReactComponent as EditBSolid } from '../../../assets/icons/solid/general/EDIT-B.svg?react';
import { createIcons } from '../../Icon';
const EditBIcon = /* @__PURE__ */ createIcons('EditB', {
    default: EditBDefault,
    solid: EditBSolid
});
EditBIcon.supportedTypes = ['default', 'solid'];
EditBIcon.category = 'general';
export default EditBIcon;
